import React from 'react';

import styled from 'styled-components';

import {Caret, colors, dimensions} from '@stryd/react-ui';

const Button = styled.div`
  font-size: 14px;
  background-color: ${colors.themes.dark.buttonDisabled};
  padding: 7px 20px;
  border-radius: 25px;
  transition: 0.2s background-color, 0.2s color;
  right: 0;
  text-transform: capitalize;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background-color: ${colors.themes.dark.infoBtnBackgroundHover};
    color: ${colors.themes.dark.buttonPrimaryText};
  }
  &:hover div {
    transition: 0.2s transform, 0.2s border-top;
    border-top: 5px solid ${colors.themes.dark.text};
  }
  &.active {
    background-color: ${colors.themes.dark.infoBtnBackgroundHover};
    color: ${colors.themes.dark.buttonPrimaryText};
  }
  &.open {
    background-color: ${colors.themes.dark.infoBtnBackground + '33'};
    box-shadow: 0px 0px 0px 2px ${colors.themes.dark.hoverBoxShadow} inset;
    color: ${colors.themes.dark.buttonPrimaryText};
  }
  @media screen and (max-width: ${dimensions.breakpoints.tabletLandscape}) {
    margin-bottom: 10px;
  }
`;

type FilterButtonProps = {
  menuOpen: boolean;
  isActive: boolean;
  filterValue: string | boolean | never[];
  onClick: () => void;
  label: string;
  showCaret?: boolean;
};

export const FilterButton: React.FC<
  React.PropsWithChildren<FilterButtonProps>
> = ({menuOpen, isActive, filterValue, onClick, label, showCaret = true}) => {
  return (
    <Button
      className={`${menuOpen ? 'open' : ''} ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      {label}
      {Array.isArray(filterValue)
        ? filterValue.length
          ? ` (${filterValue.length})`
          : ''
        : ''}
      {showCaret && (
        <>
          <Caret
            color={menuOpen || isActive ? 'white' : 'black'}
            rotation={menuOpen ? '-180deg' : '0deg'}
          />{' '}
        </>
      )}
    </Button>
  );
};
